import { render, staticRenderFns } from "./SwitchApi.vue?vue&type=template&id=37bdcd8f&"
import script from "./SwitchApi.vue?vue&type=script&lang=js&"
export * from "./SwitchApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports